module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Odometer","commonjs2":"odometer","commonjs":"odometer","amd":"odometer"}
// module id = 4
// module chunks = 0